import React from 'react';
import { Image } from 'react-native';
import { useChecklistMediaPreview } from '@/hooks/useChecklistMediaPreview';
import { parsePartnerStorageReference } from '@/utils/media/partnerStorageReference';

export const PartnerMediaThumbnail = ({ value, checklistId }: { value: string; checklistId: string }) => {
  const ref = parsePartnerStorageReference(value);
  const uri = useChecklistMediaPreview(value, '', 'image/jpeg', { companyId: ref?.companyId ?? '', checklistId });
  return uri ? <Image source={{ uri }} style={{ width: 60, height: 60, marginRight: 6, borderRadius: 4 }} resizeMode="cover" /> : null;
};
